import { select } from '@/services/siteCenterCapacityMonitor';
import moment from 'moment';
import { getAccess } from '@/services/area';

const getDefaultDateRange = () => [
  moment().hour(12).minute(0).second(0),
  moment().add(1, 'day').hour(12).minute(0).second(0),
];

const getDefaultDeliveryCenter = () => {
  const access = getAccess();
  if (
    (access?.siteTypeCode === '900100' || access?.siteTypeCode === '900200') &&
    access?.siteCode &&
    access?.siteName
  ) {
    return { code: access.siteCode, name: access.siteName };
  }
  return {};
};

export default {
  namespace: 'siteCenterCapacityMonitor',
  state: {
    dateRange: getDefaultDateRange(),
    deliveryCenter: getDefaultDeliveryCenter(),
    tableData: [],
  },
  effects: {
    *getTableData(_, { call, put, select: selectState }) {
      const { dateRange, deliveryCenter } = yield selectState(
        ({ siteCenterCapacityMonitor }) => siteCenterCapacityMonitor,
      );
      const res = yield call(select, {
        startDate: dateRange?.[0]?.format('YYYY-MM-DD HH:mm'),
        endDate: dateRange?.[1]?.format('YYYY-MM-DD HH:mm'),
        deliveryCenterCode: deliveryCenter?.code,
        deliveryCenterName: deliveryCenter?.name,
      });

      yield put({
        type: 'updateData',
        payload: {
          tableData: Array.isArray(res?.data) ? res.data : res?.data?.rows || [],
        },
      });
    },
  },
  reducers: {
    updateData(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
